import { useEffect, useState } from 'react';

const useCheckMobileScreen = (size?: number) => {
    const [width, setWidth] = useState(window.innerWidth);
    const handleWindowSizeChange = () => {
        setWidth(window.innerWidth);
    };

    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        };
    }, []);

    const smallSize = width <= size || (width <= 837 && width >= 556);
    const largeSize = width >= 1672;
    return { largeSize, smallSize };
};

export default useCheckMobileScreen;
